export const ROLES = {
    PDFVIEWER_ROLES: ['SERVICE_ALL', 'DOCUMENTATION']
};
